/*
 * -----------------------------------------------------------------------
 *  <copyright file="study-treatment-arms.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { gql } from '@apollo/client';
import { StudyTreatmentArmFragment } from './fragments';

export const GET_STUDY_TREATMENT_ARMS = gql`
    query treatmentArms($studyId: ObjectId!, $timestamp: DateTime) {
        treatmentArms(studyId: $studyId, timestamp: $timestamp) {
            ...StudyTreatmentArmFields
        }
    }
    ${StudyTreatmentArmFragment}
`;

export const SAVE_STUDY_TREATMENT_ARM = gql`
    mutation upsertTreatmentArm($studyId: ObjectId!, $treatmentArm: StudyTreatmentArmInput!, $reason: String) {
        upsertTreatmentArm(studyId: $studyId, treatmentArm: $treatmentArm, reason: $reason) {
            ...StudyTreatmentArmFields
        }
    }
    ${StudyTreatmentArmFragment}
`;
